import React, { Component } from 'react'
import { Table, Card, Tag, Form, Icon, Spin, Button, Tooltip, Modal, Col, Row, DatePicker, Select, Input, Pagination } from 'antd';
import CatalogosRequest from '../../../services/Catalogo';
import { openNotification } from '../../../util/notificaciones';
import moment from 'moment'
import 'moment/locale/es';
import { roles } from '../../../util/Roles';
// import PedidosPerfectosRequest from '../../services/ReportePedidosPerfectos';
import * as Excel from "exceljs";
import { saveAs } from "file-saver";
import DetalleDiferenciaInventario from './DetalleDiferenciaInventario';
import CatalogoRequest from '../../../services/Catalogo';
import ReporteRequest from '../../../services/Reportes';
import ArticulosPTRequest from '../../../services/ArticulosPT';
import { get_id } from '../../../util/IdUser';
import { T } from 'antd/lib/upload/utils';
import { esBarras } from '../../../util/generics';

moment.locale('es')

const { Option } = Select;
const { RangePicker } = DatePicker;
const dateFormat = 'DD/MM/YYYY';
const rol = localStorage.getItem("role")?.split(",");

/**
 * Clase para visualizar los pedidos realizados
 */
class DiferenciaInventario extends Component {
    state = {
        arrResultado: [],
        cargando: false,
        cargandoFiltros: false,
        filterText: "",
        fechaPedido: [],
        datesPedido: [],
        datesVencimiento: [],
        arrEstatusPedidos: [],
        objPedidoSelected: null,
        mostrarModalRecibir: false,
        mostrarModalCalificar: false,
        tipo_modal: "Recibir",
        mostrarmodalTr: false,
        cargandoTr: false,
        arrEstados: [],
        arrMunicipios: [],
        modeloSelected: null,
        disableDeleteFilters: true,
        disableApplyFilters: true,
        disableComboDrive: true,
        paginacion: {},
        mostrarModalDetalle: false,
        arrResultadoVista: [],
        total: 0,
        pageSize: 100,
        columnas: [],

        arrSegmentos: [],
        arrSucursales: [],
        arrDrives: [],
        arrTipoInventario: [],
        arrDiferencia: [],
        arrArticulos: [],

        segmentoSelected: null,
        articuloSelected: null,
        sucursalSelected: null,
        driveSelected: null,
        productoSelected: null,
        tipoInventarioSelected: null,
        diferenciaSelected: null,
        cargandoExcel: false,
        encabezado: {},
        roles: localStorage.getItem("role")?.split(","),
        firstDate: null,
    }

    /**
     * Comportamiento del componente al recibir nuevos datos
    */
    componentDidMount = () => {
        let state = { ...this.state }
        state.cargandoFiltros = true;
        state.columnas = this.setColumnas();

        state.arrTipoInventario.push({
            id: 2, nombre: 'Externo'
        });
        state.arrTipoInventario.push({
            id: 3,
            nombre: 'Interno'
        });

        state.arrDiferencia.push({
            id: 1,
            nombre: 'Faltante'
        });
        state.arrDiferencia.push({
            id: 0,
            nombre: 'Sobrante'
        });

        if (this.state.roles.length == 1 && this.state.roles.includes('Operador')) {
            this.buscarSitioPorUsuario(state).then((newState) => {
                state = newState;
                return ArticulosPTRequest.ListarArticulosInventarioSinPaginacion()
            })
                .then((response) => {
                    state.arrArticulos = response.data;
                    this.setState(state)
                }).finally(() => {
                    state.cargandoFiltros = false;
                    this.setState(state);
                })
        } else {
            CatalogoRequest.CargarSegmentos()
                .then(response => {
                    state.arrSegmentos = response.data.filter(record => record.numero == '085' || record.numero == '078')
                    this.setState(state)
                    return CatalogoRequest.CargarSucursalesRegion(0)
                })
                .then(response => {
                    state.arrSucursales = response.data;
                    if (state.arrSucursales.length) {
                        state.arrSucursales.unshift({
                            id: 0,
                            nombre: "TODOS",
                            numero: "000",
                            region: 0
                        });
                    } else {
                        state.arrSucursales.unshift({
                            id: 0,
                            nombre: "No hay resultados.",
                            nombre_corto: "No hay resultados.",
                            activo: true,
                            disable: true
                        });
                    }
                    this.setState(state);
                    // return ArticulosPTRequest.ListarArticulosInventarioSinPaginacion()
                })
                // .then((response)=>{
                //     state.arrArticulos = response.data
                //     this.setState(state);
                // })
                .finally(() => {
                    state.cargandoFiltros = false;
                    this.setState(state);
                })
                .catch(err => {
                    openNotification(
                        "Ha ocurrido un error al listar los catalogos.",
                        "Error"
                    )
                });

        }
    }

    buscarSitioPorUsuario(state) {
        return new Promise((resolve, reject) => {
            CatalogoRequest.CargarSitiosByUsuario(get_id())
                .then(response => {
                    state.arrDrives = response.data;
                    this.setState(state, () => {
                        if (response.data.length === 1) {
                            state.driveSelected = response.data[0].id;
                            this.setState(state);
                        }
                        if (!response.data.length) {
                            if (rol.includes(roles.Operador)) {
                                const error = esBarras()
                                    ? "El usuario no tiene asignada una barra, favor de contactar al Administrador."
                                    : "El usuario no tiene asignado un punto de venta, favor de contactar al Administrador."
                                openNotification(
                                    error,
                                    "Error"
                                )
                            } else {
                                const mensajeError = esBarras()
                                    ? "El usuario no tiene asignada una barra, deberá configurarlo en el módulo de usuarios."
                                    : "El usuario no tiene asignado un punto de venta, deberá configurarlo en el módulo de usuarios."
                                openNotification(
                                    mensajeError,
                                    "Aviso"
                                )
                            }
                        }
                        resolve(state);
                    })
                })
                .catch(err => {
                    openNotification(
                        "Ha ocurrido un error al listar los puntos de venta del usuario.",
                        "Error"
                    )
                    reject();
                })
        })

    }

    /**
     * Función para procesar las entradas de texto y eliminar espacios así como
     * caracteres especiales
     * @param: input. entrada de texto al select
     * @param: option. opciones para el filtrado
     * @return: Booleano que indica si la opcion contiene al input
     */
    sanitizerTexto = (input, option) => {
        return option.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim()
            .toLowerCase().includes(input.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase())
    }

    /**
     * Se ejecuta cuando se van a realizar filtrados
    */
    applyFilters = () => {
        let state = { ...this.state };
        let filtros = {};
        state.disableDeleteFilters = !state.fechaPedido.length

        filtros.fecha_inicial = state.datesPedido.length ? state.datesPedido[0] : null
        filtros.fecha_final = state.datesPedido.length ? state.datesPedido[1] : null

        filtros.id_tipo_inventario = state.tipoInventarioSelected;
        filtros.id_tipo_diferencia = state.diferenciaSelected;
        filtros.drive_id = state.driveSelected;
        filtros.sucursal_id = state.sucursalSelected;
        filtros.articulo_id = state.articuloSelected;
        if (state.fechaPedido) {
            if (filtros.fecha_inicial && filtros.fecha_final) {
                let f = filtros.fecha_inicial;
                if (typeof (f) == 'str') {
                    filtros.fecha_inicial = `${f.substr(6, 4)}-${f.substr(3, 2)}-${f.substr(0, 2)}`
                }
                f = filtros.fecha_final;
                if (typeof (f) == 'str') {
                    filtros.fecha_final = `${f.substr(6, 4)}-${f.substr(3, 2)}-${f.substr(0, 2)}`
                }
            }
        }
        // filtros.estado_id = state.estadoSelected;
        // filtros.ciudad_id = state.ciudadSelected;
        if (filtros.fecha_inicial && filtros.fecha_final) {
            state.cargando = true
            this.setState(state, () => {
                ReporteRequest.DiferenciaInventario(filtros).then(response => {
                    state.encabezado = response.data.resultado.length > 0 ? response.data.resultado.shift().encabezado : {};

                    state.arrResultado = response.data.resultado;
                    const pageSize = state.pageSize;
                    state.total = state.arrResultado.length;
                    state.arrResultadoVista = state.arrResultado.filter((item, index) => {
                        if (pageSize > index) {
                            return true;
                        }
                    })
                    state.cargando = false;
                    state.columnas = this.setColumnas();
                    this.setState(state)
                }).catch(err => {
                    console.error('error >>>>>><<', err)
                    openNotification("Ocurrió un error al realizar los filtrados", "Error", false);
                    this.setState({ cargando: false })
                })
            })
        }
    }

    /**
     * Se ejecuta cuando se van a borrar filtrados
     */
    deleteFilters = () => {
        let state = { ...this.state };
        state.filterTextPedidos = '';
        state.estatusSelected = undefined;
        state.fechaPedido = [];
        state.fechaVencimiento = [];
        state.datesPedido = [];
        state.datesVencimiento = [];
        state.disableDeleteFilters = true;
        state.arrMunicipios = [];
        state.arrResultado = [];
        state.estadoSelected = null;
        state.ciudadSelected = null;
        state.arrResultadoVista = [];
        state.total = 0;

        if (!(this.state.roles.length == 1 && this.state.roles.includes('Operador'))) {
            state.arrDrives = [];
            state.driveSelected = null;
        }

        state.segmentoSelected = null;
        state.articuloSelected = null;
        state.sucursalSelected = null;
        state.productoSelected = null;
        state.tipoInventarioSelected = null;
        state.diferenciaSelected = null;

        state.fechaPedido = [moment(), moment()];
        state.datesPedido = [moment(), moment()];

        this.setState(state);

        setTimeout(() => {
            state.fechaPedido = [];
            state.datesPedido = [];
            this.setState(state);
        }, 250);
    }

    /**
     * Función que se cambia la plaza
     * @param: value. valor del id de la plaza
     * @return: nada.
     */
    handleChangeEstado = (value) => {
        let state = { ...this.state }
        if (value === undefined) {
            state.estadoSelected = null;
        } else {
            state.estadoSelected = value
            state.ciudadSelected = null;
            CatalogosRequest.ListarCiudades(state.estadoSelected)
                .then(response => {
                    state.arrMunicipios = response.data;
                    if (state.arrMunicipios.length) {
                        state.arrMunicipios.unshift({
                            id: 0,
                            nombre: 'TODOS',
                            idEstado: 0
                        });
                    } else {
                        state.arrMunicipios.unshift({
                            id: 0,
                            nombre: 'No hay resultados',
                            idEstado: 0,
                            disable: true
                        });
                    }
                    this.setState(state, this.applyFilters);
                })
                .catch(err => {
                    openNotification("Ocurrió un error al cargar las ciudades", "Error", false);
                });
        }
        this.setState(state);
    }

    handleChangeCiudad = (value) => {
        let state = { ...this.state }
        if (value === undefined) {
            state.ciudadSelected = null;
        } else {
            state.ciudadSelected = value
        }
        this.setState(state, this.applyFilters);
    }

    handleSearchArticulo = (info) => {
        let state = { ...this.state };
        let busqueda = state.filterText.trim() === "" ? undefined : state.filterText.trim()
        let ruta = ArticulosPTRequest.ListarArticulosInventarioSinPaginacion(busqueda)
        this.setState(state, () => {
            ruta.then(response => {
                state.arrArticulos = response.data
                state.cargando = false

                this.setState(state)
            }).catch(err => {
                this.setState({ cargando: false })
                openNotification(err?.response?.data?.cuerpo, "Error")
            })
        })
    }

    descargarReporte = async () => {
        let state = { ...this.state }
        this.setState({ cargandoExcel: true });
        let estado = state.estadoSelected != null ? state.arrEstados.filter(element => state.estadoSelected == element.id)[0].nombre : 'TODOS';
        let ciudad = state.ciudadSelected != null ? state.arrMunicipios.filter(element => state.ciudadSelected == element.id)[0].nombre : 'TODOS';

        let drive = state.driveSelected != null ? state.arrDrives.filter(element => state.driveSelected == element.id)[0].nombre : 'TODOS';
        let dia_actual = moment(new Date()).format("DD/MM/YYYY")

        const fecha_inicial = state.datesPedido.length ? state.datesPedido[0] : null
        const fecha_final = state.datesPedido.length ? state.datesPedido[1] : null

        let datos_variables = {
            'Drive': drive,
            'Periodo': fecha_inicial + ' - ' + fecha_final,
            'Día de reporte': dia_actual
        }


        var wb = new Excel.Workbook();
        var ws = wb.addWorksheet('Reporte de diferencia de inventarios.');

        const fontStyle = {
            name: 'Arial',
            color: { argb: 'FFFFFFFF' },
            bold: true,
            size: 12
        }
        const alignmentStyle = {
            vertical: 'middle',
            horizontal: 'center'
        }
        const borderStyle = {
            top: { color: { rgb: '110, 105, 105' } },
            left: { color: { rgb: '110, 105, 105' } },
            bottom: { color: { rgb: '110, 105, 105' } },
            right: { color: { rgb: '110, 105, 105' } }
        }
        const fillStyle = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '506e6969' }
        }
        const styleFormat = {
            font: fontStyle,
            alignment: alignmentStyle,
            border: borderStyle,
            fill: fillStyle
        }
        const styleFormatEncabezado = {
            fill: {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'e3e3e3' }
            }
        }

        ws.mergeCells('D1', 'D2');
        ws.mergeCells('E1', 'E2');
        ws.mergeCells('F1', 'F2');
        ws.mergeCells('G1', 'G2');
        ws.mergeCells('H1', 'H2');
        ws.mergeCells('I1', 'I2');
        ws.mergeCells('J1', 'J2');
        ws.mergeCells('K1', 'K2');
        ws.mergeCells('L1', 'L2');
        ws.mergeCells('M1', 'M2');
        ws.mergeCells('N1', 'N2');
        ws.mergeCells('O1', 'O2');
        ws.mergeCells('P1', 'P2');
        ws.mergeCells('Q1', 'Q2');
        ws.mergeCells('R1', 'R2');
        ws.mergeCells('S1', 'S2');
        ws.mergeCells('T1', 'T2');
        ws.columns = [
            { key: 'A', width: 20 },
            { key: 'B', width: 25 },
            { key: 'C', width: 5 },
            { header: 'Fecha (d/m/a)', key: 'Fecha', width: 20 },
            { header: 'Drive', key: 'Drive', width: 20 },
            { header: 'Documento', key: 'Documento', width: 20 },
            { header: 'Empleado', key: 'Empleado', width: 20 },
            { header: 'Código', key: 'CodigoInventario', width: 20 },
            { header: 'Nombre', key: 'Articulo', width: 20 },
            { header: 'Inventario inicial', key: 'InventarioInicial', width: 20 },
            { header: 'Remesas', key: 'Remesas', width: 20 },
            { header: 'Ventas', key: 'Ventas', width: 20 },
            { header: 'Mermas', key: 'Mermas', width: 20 },
            { header: 'Existencia', key: 'Existencia', width: 20 },
            { header: 'Unidad', key: 'Unidad', width: 20 },
            { header: 'Conteo', key: 'Conteo', width: 20 },
            { header: 'Diferencia', key: 'Diferencia', width: 20 },
            { header: 'Costo diferencia', key: 'CostoDiferencia', width: 20 },
            { header: 'Sobrante', key: 'Sobrante', width: 20 },
            { header: 'Faltante', key: 'Faltante', width: 20 },
        ]

        ws.getRow(1).height = 20;
        ws.getCell('D1').style = styleFormat;
        ws.getCell('E1').style = styleFormat;
        ws.getCell('F1').style = styleFormat;
        ws.getCell('G1').style = styleFormat;
        ws.getCell('H1').style = styleFormat;
        ws.getCell('I1').style = styleFormat;
        ws.getCell('J1').style = styleFormat;
        ws.getCell('K1').style = styleFormat;
        ws.getCell('L1').style = styleFormat;
        ws.getCell('M1').style = styleFormat;
        ws.getCell('N1').style = styleFormat;
        ws.getCell('O1').style = styleFormat;
        ws.getCell('P1').style = styleFormat;
        ws.getCell('Q1').style = styleFormat;
        ws.getCell('R1').style = styleFormat;
        ws.getCell('S1').style = styleFormat;
        ws.getCell('T1').style = styleFormat;

        let rowsAgroup = []
        let documento = [];
        for (const element of state.arrResultado) {
            documento.push(element.encabezado.Documento);
        }

        const response = await ReporteRequest.DiferenciaInventario({ documento: documento });//.then(response => {
        for (let index = 0; index < state.arrResultado.length; index++) {
            if (!state.articuloSelected) {
                const fecha = state.arrResultado[index].encabezado.Fecha;
                const rowCreate = ws.addRow({
                    Fecha: `${fecha.substr(8, 2)}/${fecha.substr(5, 2)}/${fecha.substr(0, 4)} ${fecha.substr(11, 2)}:${fecha.substr(14, 2)}`,
                    Drive: state.arrResultado[index].encabezado.Drive,
                    Documento: state.arrResultado[index].encabezado.Documento,
                    Empleado: state.arrResultado[index].encabezado.Empleado,
                    CodigoInventario: '',
                    Articulo: '',
                    InventarioInicial: '',
                    Remesas: '',
                    Ventas: '',
                    Mermas: '',
                    Existencia: '',
                    Unidad: '',
                    Conteo: '',
                    Diferencia: state.arrResultado[index].encabezado.Diferencia.toFixed(3),
                    CostoDiferencia: state.arrResultado[index].encabezado.CostoDiferencia,
                    Sobrante: state.arrResultado[index].encabezado.Sobrante,
                    Faltante: state.arrResultado[index].encabezado.Faltante
                });
                rowsAgroup.push(rowCreate.number);
                rowCreate.getCell(`D`).style = styleFormatEncabezado;
                rowCreate.getCell(`E`).style = styleFormatEncabezado;
                rowCreate.getCell(`F`).style = styleFormatEncabezado;
                rowCreate.getCell(`G`).style = styleFormatEncabezado;
                rowCreate.getCell(`H`).style = styleFormatEncabezado;
                rowCreate.getCell(`I`).style = styleFormatEncabezado;
                rowCreate.getCell(`J`).style = styleFormatEncabezado;
                rowCreate.getCell(`K`).style = styleFormatEncabezado;
                rowCreate.getCell(`L`).style = styleFormatEncabezado;
                rowCreate.getCell(`M`).style = styleFormatEncabezado;
                rowCreate.getCell(`N`).style = styleFormatEncabezado;
                rowCreate.getCell(`O`).style = styleFormatEncabezado;
                rowCreate.getCell(`P`).style = styleFormatEncabezado;
                rowCreate.getCell(`Q`).style = styleFormatEncabezado;
                rowCreate.getCell(`R`).style = styleFormatEncabezado;
                rowCreate.getCell(`S`).style = styleFormatEncabezado;
                rowCreate.getCell(`T`).style = styleFormatEncabezado;

                // rowCreate.getCell(`Q`).numFmt = '0.000';
                rowCreate.getCell(`R`).numFmt = '$0.000';
                rowCreate.getCell(`S`).numFmt = '$0.000';
                rowCreate.getCell(`T`).numFmt = '$0.000';

                // const response = await ReporteRequest.DiferenciaInventario({documento:documento});//.then(response => {
                const detalle = response.data.resultado.length > 0 ? response.data.resultado[index].detalle : [];
                detalle.forEach((itemDetalle, indx) => {
                    const RowCreateDetalle = ws.addRow({
                        Fecha: '',
                        Drive: '',
                        Documento: '',
                        Empleado: '',
                        CodigoInventario: itemDetalle.Pt,
                        Articulo: itemDetalle.Nombre,
                        InventarioInicial: itemDetalle.InventarioInicial.toFixed(3),
                        Remesas: itemDetalle.Remesas.toFixed(3),
                        Ventas: itemDetalle.Ventas.toFixed(3),
                        Mermas: itemDetalle.Mermas.toFixed(3),
                        Existencia: itemDetalle.Existencia.toFixed(3),
                        Unidad: itemDetalle.Unidad,
                        Conteo: itemDetalle.Conteo.toFixed(3),
                        Diferencia: itemDetalle.Diferencia,
                        CostoDiferencia: itemDetalle.CostoDiferencia,
                        Sobrante: itemDetalle.Sobrante,
                        Faltante: itemDetalle.Faltante,
                    });
                    RowCreateDetalle.getCell(`Q`).numFmt = '0.000';
                    RowCreateDetalle.getCell(`R`).numFmt = '$0.000';
                    RowCreateDetalle.getCell(`S`).numFmt = '$0.000';
                    RowCreateDetalle.getCell(`T`).numFmt = '$0.000';
                });
                // }).catch(err => {
                //     console.error('error >>>>>><<',err)
                //     openNotification("Ocurrió un error al realizar los filtrados", "Error", false);
                //     this.setState({ cargando: false })
                // })

            } else {
                const fecha = state.arrResultado[index].encabezado.Fecha;
                const rowCreate = ws.addRow({
                    Fecha: `${fecha.substr(8, 2)}/${fecha.substr(5, 2)}/${fecha.substr(0, 4)} ${fecha.substr(11, 2)}:${fecha.substr(14, 2)}`,
                    Drive: state.arrResultado[index].encabezado.Drive,
                    Documento: state.arrResultado[index].encabezado.Documento,
                    Empleado: state.arrResultado[index].encabezado.Empleado,
                    CodigoInventario: state.arrResultado[index].encabezado.Pt,
                    Articulo: state.arrResultado[index].encabezado.Nombre,
                    InventarioInicial: state.arrResultado[index].encabezado.InventarioInicial.toFixed(3),
                    Remesas: state.arrResultado[index].encabezado.Remesas.toFixed(3),
                    Ventas: state.arrResultado[index].encabezado.Ventas.toFixed(3),
                    Mermas: state.arrResultado[index].encabezado.Mermas.toFixed(3),
                    Existencia: state.arrResultado[index].encabezado.Existencia.toFixed(3),
                    Unidad: state.arrResultado[index].encabezado.Unidad,
                    Conteo: state.arrResultado[index].encabezado.Conteo.toFixed(3),
                    Diferencia: state.arrResultado[index].encabezado.Diferencia,
                    CostoDiferencia: state.arrResultado[index].encabezado.CostoDiferencia,
                    Sobrante: state.arrResultado[index].encabezado.Sobrante,
                    Faltante: state.arrResultado[index].encabezado.Faltante
                });
                rowsAgroup.push(rowCreate.number);
                rowCreate.getCell(`D`).style = styleFormatEncabezado;
                rowCreate.getCell(`Q`).numFmt = '0.000';
                rowCreate.getCell(`R`).numFmt = '$0.000';
                rowCreate.getCell(`S`).numFmt = '$0.000';
                rowCreate.getCell(`T`).numFmt = '$0.000';
            }
        }

        let indice_row = 1;  // Contador para los renglones del archivo.
        Object.entries(datos_variables).forEach(arr => {
            ws.getRow(indice_row).getCell(1).value = arr[0];
            ws.getCell(`A${indice_row}`).style = styleFormat;
            ws.getRow(indice_row).getCell(2).value = arr[1];
            indice_row += 1;
        })

        indice_row += 2;
        ws.getRow(indice_row).getCell(1).value = 'Descripción';
        ws.getRow(indice_row).getCell(1).style = styleFormat;
        ws.getRow(indice_row).getCell(2).value = 'Total';
        ws.getRow(indice_row).getCell(2).style = styleFormat;
        indice_row += 1;
        if (this.state.encabezado) {
            Object.keys(this.state.encabezado).forEach(key => {
                ws.getRow(indice_row).getCell(1).value = (key == 'CostoDiferencia' ? 'Costo diferencia' : key) + ': ';
                ws.getRow(indice_row).getCell(2).value = (key != 'Diferencia' ? '$' : '') + this.state.encabezado[key].toFixed(3);
                indice_row += 1;
            });
        }

        wb.creator = 'Inventario';
        wb.title = `Archivo para ver el reporte de diferencia de inventarios`;

        wb.xlsx.writeBuffer()
            .then(buffer => {
                var data = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                saveAs(data, `Reporte de diferencia inventario.xlsx`);
            })
        this.setState({ cargandoExcel: false });
    }

    onChangePagination = (page, size) => {
        let state = { ...this.state };
        const inicio = (page * size) - size;
        const fin = (page * size);
        state.arrResultadoVista = [];
        state.arrResultadoVista = state.arrResultado.filter((item, index) => {
            if (index >= inicio && index < fin) {
                return true;
            }
        });
        window.scrollTo(0, 0);
        this.setState(state);
    }

    handleChangeSegmento = (value) => {
        let state = { ...this.state }
        if (value === undefined) {
            state.segmentoSelected = null;
        } else {
            state.segmentoSelected = value;
            state.driveSelected = null;
            state.arrResultadoVista = [];
            state.total = 0;

        }
        this.setState(state, this.buscarSitio);
    }

    handleChangeSucursal = (value) => {
        let state = { ...this.state }
        if (value === undefined) {
            state.sucursalSelected = null;
        } else {
            state.sucursalSelected = value;
            state.driveSelected = null;
            state.arrResultadoVista = [];
            state.total = 0;
        }
        this.setState(state, value ? this.buscarSitio : this.applyFilters);
    }

    handleChangeDrive = (value) => {
        let state = { ...this.state }
        if (value === undefined) {
            state.driveSelected = null;
        } else {
            state.driveSelected = value;
        }
        this.setState(state, this.applyFilters);
    }

    handleChangeSupervisor = (value) => {
        let state = { ...this.state }
        if (value === undefined) {
            state.supervisorSelected = null;
        } else {
            state.supervisorSelected = value
        }
        this.setState(state, this.applyFilters);
    }

    handleChangeTipoInventario = (value) => {
        let state = { ...this.state }
        if (value === undefined) {
            state.tipoInventarioSelected = null;
        } else {
            state.tipoInventarioSelected = value
        }
        this.setState(state, this.applyFilters);
    }

    handleChangeDiferencia = (value) => {
        let state = { ...this.state }
        if (value === undefined) {
            state.diferenciaSelected = null;
        } else {
            state.diferenciaSelected = value
        }
        this.setState(state, this.applyFilters);
    }

    handleChangeProducto = (value) => {
        let state = { ...this.state }
        if (value === undefined) {
            state.articuloSelected = null;
        } else {
            state.articuloSelected = value
        }
        this.setState(state, this.applyFilters);
    }

    buscarSitio = () => {
        let state = { ...this.state }

        CatalogoRequest.CargarSitiosPlaza(-1, 0, state.sucursalSelected, state.segmentoSelected).then(response => {
            state.arrDrives = response.data;
            if (state.arrDrives.length) {
                state.arrDrives.unshift({ id: 0, plaza: 0, cr: 'TODOS', nombre: 'TODOS', plaza_nombre: 'TODOS' })
            } else {
                state.arrDrives.unshift({ id: 0, plaza: 0, cr: 'No hay resultados', nombre: 'No hay resultados', plaza_nombre: 'No hay resultados', disable: true })
            }
            this.setState(state)
        }).catch(err => {
            openNotification(
                "Ha ocurrido un error al cargar los drives de la plaza.",
                "Error",
                false
            )
        })
    }

    setColumnas() {
        let state = { ...this.state }
        let columnas
        if (!state.articuloSelected) {
            columnas = [
                {
                    title: "Fecha (dd/mm/aaaa)",
                    dataIndex: "Ubicacion",
                    key: "Fecha",
                    width: '10%',
                    render: (value, record) => (
                        // 2020-06-03T21:04:26
                        <div> {record.encabezado.Fecha.substring(8, 10) + '/' + record.encabezado.Fecha.substring(5, 7) + '/' + record.encabezado.Fecha.substring(0, 4) + ' ' + record.encabezado.Fecha.substring(11, 13) + ':' + record.encabezado.Fecha.substring(14, 16)}</div>
                    )
                },
                {
                    title: "Drive",
                    dataIndex: "Pedidos_realizados",
                    key: "Pedidos_realizados",
                    render: (value, record) => (
                        <div>{record.encabezado.Drive}</div>
                    )
                },
                {
                    title: "Documento",
                    dataIndex: "Pedidos_perfectos",
                    key: "Pedidos_perfectos",
                    width: '10%',
                    render: (value, record) => (
                        <div>{record.encabezado.Documento}</div>
                    )
                },
                {
                    title: 'Empleado',
                    dataIndex: 'Empleado',
                    key: 'Empleado',
                    render: (value, record) => (
                        <div>{record.encabezado.Empleado}</div>
                    )
                },
                {
                    title: 'Diferencia',
                    dataIndex: 'Diferencia',
                    key: 'Diferencia',
                    render: (value, record) => (
                        <div>{record.encabezado.Diferencia.toFixed(3)}</div>
                    )
                },
                {
                    title: 'Costo diferencia',
                    dataIndex: 'Costodiferencia',
                    key: 'Costodiferencia',
                    render: (value, record) => (
                        <div>{`$${record.encabezado.CostoDiferencia.toFixed(3)}`}</div>
                    )
                },
                {
                    title: 'Sobrante',
                    dataIndex: 'Sobrante',
                    key: 'Sobrante',
                    render: (value, record) => (
                        <div>{`$${record.encabezado.Sobrante.toFixed(3)}`}</div>
                    )
                },
                {
                    title: 'Faltante',
                    dataIndex: 'Faltante',
                    key: 'Faltante',
                    render: (value, record) => (
                        <div>{`$${record.encabezado.Faltante.toFixed(3)}`}</div>
                    )
                },
                {
                    title: 'Acciones',
                    dataIndex: 'Acciones',
                    key: 'Acciones',
                    render: (value, record) => (
                        <div>
                            <div>
                                <span style={{ marginRight: 5 }}>
                                    <Tooltip placement="top" title={"Ver detalle"}>
                                        <Button
                                            icon="eye"
                                            className="btnVerCrearGuardar"
                                            onClick={() => {
                                                let state = { ...this.state }
                                                let filtros = {};
                                                filtros.fecha_inicial = state.datesPedido.length ? state.datesPedido[0] : null
                                                filtros.fecha_final = state.datesPedido.length ? state.datesPedido[1] : null

                                                if (state.fechaPedido) {
                                                    if (filtros.fecha_inicial && filtros.fecha_final) {
                                                        let f = filtros.fecha_inicial;
                                                        if (typeof (f) == 'str') {
                                                            filtros.fecha_inicial = `${f.substr(6, 4)}-${f.substr(3, 2)}-${f.substr(0, 2)}`
                                                        }
                                                        f = filtros.fecha_final;
                                                        if (typeof (f) == 'str') {
                                                            filtros.fecha_final = `${f.substr(6, 4)}-${f.substr(3, 2)}-${f.substr(0, 2)}`
                                                        }
                                                    }
                                                }
                                                state.objPedidoSelected = record;
                                                state.mostrarModalDetalle = true;
                                                this.setState(state)
                                            }
                                            }
                                        >
                                        </Button>
                                    </Tooltip>
                                </span>
                            </div>
                        </div>
                    )
                }
            ]

        } else {
            columnas = [
                {
                    title: "Fecha (d/m/a)",
                    dataIndex: "Ubicacion",
                    key: "Fecha",
                    width: '10%',
                    render: (value, record) => (
                        // 2020-06-03T21:04:26
                        <div> {record.encabezado.Fecha.substring(8, 10) + '/' + record.encabezado.Fecha.substring(5, 7) + '/' + record.encabezado.Fecha.substring(0, 4) + ' ' + record.encabezado.Fecha.substring(11, 13) + ':' + record.encabezado.Fecha.substring(14, 16)}</div>
                    )
                },
                {
                    title: "Drive",
                    dataIndex: "Pedidos_realizados",
                    key: "Pedidos_realizados",
                    render: (value, record) => (
                        <div>{record.encabezado.Drive}</div>
                    )
                },
                {
                    title: "Documento",
                    dataIndex: "Pedidos_perfectos",
                    key: "Pedidos_perfectos",
                    width: '10%',
                    render: (value, record) => (
                        <div>{record.encabezado.Documento}</div>
                    )
                },
                {
                    title: 'Empleado',
                    dataIndex: 'Empleado',
                    key: 'Empleado',
                    render: (value, record) => (
                        <div>{record.encabezado.Empleado}</div>
                    )
                },
                {
                    title: "Inventario inicial",
                    dataIndex: "InventarioInicial",
                    key: "InventarioInicial",
                    render: (value, record) => (
                        <div>{record.encabezado.InventarioInicial.toFixed(3)}</div>
                    )
                },
                {
                    title: "Remesas",
                    dataIndex: "Remesas",
                    key: "Remesas",
                    render: (value, record) => (
                        <div>{record.encabezado.Remesas.toFixed(3)}</div>
                    )
                },
                {
                    title: "Ventas",
                    dataIndex: "Ventas",
                    key: "Ventas",
                    render: (value, record) => (
                        <div>{record.encabezado.Ventas.toFixed(3)}</div>
                    )
                },
                {
                    title: "Mermas",
                    dataIndex: "Mermas",
                    key: "Mermas",
                    render: (value, record) => (
                        <div>{record.encabezado.Mermas.toFixed(3)}</div>
                    )
                },
                {
                    title: "Existencia",
                    dataIndex: "Existencia",
                    key: "Existencia",
                    render: (value, record) => (
                        <div>{record.encabezado.Existencia.toFixed(3)}</div>
                    )
                },
                {
                    title: "Unidad",
                    dataIndex: "Unidad",
                    key: "Unidad",
                    render: (value, record) => (
                        <div>{record.encabezado.Unidad}</div>
                    )
                },
                {
                    title: "Conteo",
                    dataIndex: "Conteo",
                    key: "Conteo",
                    render: (value, record) => (
                        <div>{record.encabezado.Conteo.toFixed(3)}</div>
                    )
                },
                {
                    title: "Diferencia",
                    dataIndex: "Diferencia",
                    key: "Diferencia",
                    render: (value, record) => (
                        <div>{record.encabezado.Diferencia.toFixed(3)}</div>
                    )
                },
                {
                    title: "Costo diferencia",
                    dataIndex: "Ventas",
                    key: "Ventas",
                    render: (value, record) => (
                        <div>{`$${record.encabezado.CostoDiferencia.toFixed(3)}`}</div>
                    )
                },
                {
                    title: "Sobrante",
                    dataIndex: "Sobrante",
                    key: "Sobrante",
                    render: (value, record) => (
                        <div>{`$${record.encabezado.Sobrante.toFixed(3)}`}</div>
                    )
                },
                {
                    title: "Faltante",
                    dataIndex: "Faltante",
                    key: "Faltante",
                    render: (value, record) => (
                        <div>{`$${record.encabezado.Faltante.toFixed(3)}`}</div>
                    )
                },
            ]
        }
        return columnas
    }

    render() {
        return (
            <Spin tip="Exportando a excel..."
                indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                spinning={this.state.cargandoExcel}
                style={{ color: "black", backgroundColor: "rgb(255,255,255,0.8)" }}>
                <Card id="" title="Diferencia de inventarios"
                    extra={
                        <div>
                            <Button id="boton-descargar-pedidos perfectos-excel"
                                type="primary"
                                style={{ marginRight: 20 }}
                                disabled={!this.state.arrResultado.length}
                                onClick={() => {
                                    this.descargarReporte()
                                }}
                            > Descargar reporte </Button>
                        </div>
                    }
                >
                    <div className="panel-block">
                        <Spin tip="Cargando filtros..."
                            indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                            spinning={this.state.cargandoFiltros}
                            style={{ color: "black", backgroundColor: "rgb(255,255,255,0.8)" }}>
                            <Row gutter={12} >
                                <Col span={6} style={{ paddingBottom: '10px' }} className={this.state.roles.length == 1 && this.state.roles.includes('Operador') ? 'display-none' : ''}>
                                    <div className="center">Segmento:</div>
                                    <Tooltip placement="top" title="Seleccione un segmento">
                                        <Select id="select-plaza-calendario-modulo"
                                            showSearch
                                            allowClear={true}
                                            style={{ width: "100%" }}
                                            defaultActiveFirstOption={false}
                                            notFoundContent='No hay opciones'
                                            placeholder="Seleccionar..."
                                            optionFilterProp="children"
                                            onChange={this.handleChangeSegmento}
                                            value={this.state.segmentoSelected}
                                        >
                                            <Option value={null} disabled={true}>Seleccionar...</Option>
                                            {
                                                this.state.arrSegmentos.length > 0 &&
                                                this.state.arrSegmentos.map(obj => {
                                                    return (
                                                        <Option
                                                            key={obj.id}
                                                            value={obj.id}>
                                                            {obj.nombre}
                                                        </Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    </Tooltip>
                                </Col>
                                <Col span={6} style={{ paddingBottom: '10px' }} className={this.state.roles.length == 1 && this.state.roles.includes('Operador') ? 'display-none' : ''}>
                                    <div className="center">Sucursal:</div>
                                    <Tooltip
                                        placement="top"
                                        title="Seleccione una sucursal">
                                        <Select
                                            id="select-sucursal-productos-modulo"
                                            showSearch
                                            allowClear={true}
                                            style={{ width: "100%" }}
                                            defaultActiveFirstOption={false}
                                            notFoundContent='No hay opciones'
                                            placeholder="Seleccionar..."
                                            optionFilterProp="children"
                                            onChange={this.handleChangeSucursal}
                                            value={this.state.sucursalSelected}
                                        >
                                            <Option value={null} disabled={true}>Seleccionar...</Option>
                                            {

                                                this.state.arrSucursales.length > 0 &&
                                                this.state.arrSucursales.map(obj => {
                                                    return (
                                                        <Option
                                                            key={obj.id}
                                                            value={obj.id}
                                                            disabled={obj.disable}>
                                                            {obj.nombre}
                                                        </Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    </Tooltip>
                                </Col>
                                <Col span={6} style={{ paddingBottom: '10px' }} >
                                    <div className="center">Drive:</div>
                                    <Tooltip
                                        placement="top"
                                        title="Seleccione un drive">
                                        <Select
                                            id="select-sitio"
                                            showSearch
                                            style={{ width: "100%" }}
                                            allowClear={!(this.state.roles.length == 1 && this.state.roles.includes('Operador'))}
                                            defaultActiveFirstOption={false}
                                            notFoundContent='No hay opciones'
                                            placeholder="Seleccionar..."
                                            optionFilterProp="children"
                                            filterOption={(input, option) => this.sanitizerTexto(input, option.props.children)}
                                            value={this.state.driveSelected}
                                            onChange={this.handleChangeDrive}
                                        >

                                            <Option value={null} disabled={true}>Seleccionar...</Option>
                                            {
                                                this.state.arrDrives.length > 0 &&
                                                this.state.arrDrives.map((obj, index) => {
                                                    return (
                                                        <Option
                                                            key={obj.id}
                                                            value={obj.id}
                                                            disabled={obj.disable}>

                                                            {obj.nombre}
                                                        </Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    </Tooltip>
                                </Col>
                                <Col span={6} style={{ paddingBottom: '10px' }} >
                                    <div className="center">Artículos:</div>
                                    <Tooltip
                                        placement="top"
                                        title="Seleccione un artículo">
                                        <Select
                                            id="select-plaza-calendario-modulo"
                                            showSearch
                                            style={{ width: "100%" }}
                                            allowClear={true}
                                            defaultActiveFirstOption={false}
                                            notFoundContent='No hay opciones'
                                            placeholder="Seleccionar..."
                                            optionFilterProp="children"
                                            onChange={this.handleChangeProducto}
                                            value={this.state.articuloSelected}
                                        >
                                            <Option value={null}>TODOS</Option>
                                            {
                                                this.state.arrArticulos.length > 0 &&
                                                this.state.arrArticulos.map(obj => {
                                                    return (
                                                        <Option
                                                            key={obj.idArticuloInventario}
                                                            value={obj.idArticuloInventario}>
                                                            {`${obj.codigoProveedor} - ${obj.nombre}`}
                                                        </Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    </Tooltip>
                                </Col>
                                <Col span={6} style={{ paddingBottom: '10px' }} >
                                    <div className="center">Tipo inventario:</div>
                                    <Tooltip
                                        placement="top"
                                        title="Seleccione un tipo de inventario">
                                        <Select
                                            id="select-plaza-calendario-modulo"
                                            showSearch
                                            style={{ width: "100%" }}
                                            allowClear={true}
                                            defaultActiveFirstOption={false}
                                            notFoundContent='No hay opciones'
                                            placeholder="Seleccionar..."
                                            optionFilterProp="children"
                                            onChange={this.handleChangeTipoInventario}
                                            value={this.state.tipoInventarioSelected}
                                        >
                                            <Option value={null} >TODOS</Option>
                                            {
                                                this.state.arrTipoInventario.length > 0 &&
                                                this.state.arrTipoInventario.map(obj => {
                                                    return (
                                                        <Option
                                                            key={obj.id}
                                                            value={obj.id}>
                                                            {obj.nombre}
                                                        </Option>
                                                    )
                                                })
                                            }

                                        </Select>
                                    </Tooltip>
                                </Col>
                                <Col span={6} style={{ paddingBottom: '10px' }} >
                                    <div className="center">Diferencia:</div>
                                    <Tooltip
                                        placement="top"
                                        title="Seleccione un tipo de diferencia">
                                        <Select
                                            id="select-plaza-calendario-modulo"
                                            showSearch
                                            allowClear={true}
                                            style={{ width: "100%" }}
                                            defaultActiveFirstOption={false}
                                            notFoundContent='No hay opciones'
                                            placeholder="Seleccionar..."
                                            optionFilterProp="children"
                                            onChange={this.handleChangeDiferencia}
                                            value={this.state.diferenciaSelected}
                                        >
                                            <Option value={null}>TODOS</Option>
                                            {
                                                this.state.arrDiferencia.length > 0 &&
                                                this.state.arrDiferencia.map(obj => {
                                                    return (
                                                        <Option
                                                            key={obj.id}
                                                            value={obj.id}>
                                                            {obj.nombre}
                                                        </Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    </Tooltip>
                                </Col>
                                {/* <Col span={6}>
                                    <div className="center">Supervisor:</div>
                                    <Tooltip
                                        placement="top"
                                        title="Seleccione un estado">
                                        <Select
                                            id="select-plaza-calendario-modulo"
                                            showSearch
                                            style={{ width: "100%" }}
                                            defaultActiveFirstOption={false}
                                            notFoundContent='No hay opciones'
                                            placeholder="Seleccionar..."
                                            optionFilterProp="children"
                                            onChange={this.handleChangeEstado}
                                            value={this.state.estadoSelected}
                                        >
                                            <Option value={null} disabled={true}>Seleccionar...</Option>
                                            {
                                                this.state.arrEstados.length > 0 &&
                                                this.state.arrEstados.map(obj => {
                                                    return (
                                                        <Option
                                                            key={obj.id}
                                                            value={obj.id}>
                                                            {obj.nombre}
                                                        </Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    </Tooltip>
                                </Col> */}
                                <Col span={6} style={{ paddingBottom: '10px' }} >
                                    <Tooltip placement="top" title="Seleccione periodo">
                                        <div className="center">Periodo:</div>
                                        <RangePicker
                                            format={dateFormat}
                                            placeholder={["Fecha Inicio", "Fecha Fin"]}
                                            value={this.state.fechaPedido}
                                            ranges={{
                                                'Hoy': [moment(), moment()],
                                                'Última Semana': [moment().subtract(6, 'days').startOf('day'), moment()],
                                                'Último Mes': [moment().subtract(29, 'days').startOf('day'), moment()]
                                            }}
                                            onOpenChange={(open) => {
                                                if (open) {
                                                    this.setState({ firstDate: null })
                                                }
                                            }}
                                            disabledDate={(current) => {
                                                let state = { ...this.state }
                                                let firstDateClone = moment(JSON.parse(JSON.stringify(state.firstDate)));
                                                return state.firstDate ? state.firstDate > current || current > firstDateClone.add(31, 'day') : false;
                                            }}
                                            onCalendarChange={(dates, dateStrings, info) => {
                                                const firstDate = dates[0];
                                                let firstDateClone = moment(JSON.parse(JSON.stringify(firstDate)));
                                                this.setState({ firstDate: firstDate, fechaPedido: [firstDate, firstDateClone.add(31, 'day')] });
                                            }}
                                            onChange={(dates, dateStrings) => {
                                                let state = { ...this.state }
                                                if (dates.length == 0 && state.fechaPedido.length != 0) {
                                                    state.fecha_inicial = moment();
                                                    state.fecha_final = moment();
                                                    state.fechaPedido = [moment(), moment()];
                                                    state.datesPedido = [moment(), moment()];
                                                    this.setState(state);
                                                    setTimeout(() => {
                                                        state.fechaPedido = [];
                                                        state.datesPedido = [];
                                                        this.setState(state);
                                                    }, 500);
                                                } else {
                                                    const diasDiferencia = dates[1].diff(dates[0], 'days')
                                                    if (diasDiferencia > 31) {
                                                        openNotification(
                                                            "El rango de fechas no debe de exceder más de 31 días.",
                                                            "Aviso"
                                                        )
                                                        this.setState({ fechaPedido: dates, datesPedido: dateStrings });
                                                    } else {
                                                        this.setState({ fechaPedido: dates, datesPedido: dateStrings }, () => {
                                                            this.applyFilters()
                                                        })
                                                    }
                                                }
                                            }}
                                        />
                                    </Tooltip>
                                </Col>
                                <Col span={2} >
                                    <div>
                                        <Tooltip placement="top" title="Borrar filtros">
                                            <Button type="default" icon="delete" className={this.state.disableDeleteFilters ? 'disableBtn' : ''} style={{ width: '80%', marginLeft: '2.5%', marginBottom: "30px", marginTop: '1.1em' }} onClick={this.deleteFilters}></Button>
                                        </Tooltip>
                                    </div>
                                </Col>
                            </Row>
                            <Row className={this.state.arrResultado.length > 0 ? '' : 'display-none'} style={{ paddingBottom: "10px", fontWeight: 'bold' }}>
                                <div>
                                    <span>Totales:</span>
                                </div>
                                {this.state.encabezado && Object.keys(this.state.encabezado).map((key) => (
                                    <Col span={6} style={{ paddingRight: '5px', paddingTop: '5px' }}>
                                        <div style={{ padding: '2rem', backgroundColor: '#b4b3b394', display: 'grid', textAlign: 'center', borderRadius: '3rem' }}>
                                            <span>{(key == 'CostoDiferencia' ? 'Costo diferencia' : key) + ': '}</span>
                                            <span>{`${key != 'Diferencia' ? '$' : ''}` + this.state.encabezado[key].toFixed(3)}</span>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </Spin>

                        <Spin
                            tip="Cargando..."
                            indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                            spinning={this.state.cargando}
                            style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                            <Table
                                size="small"
                                pagination={false}
                                locale={{ emptyText: 'No se han encontrado resultados.' }}
                                rowKey={pedidos => pedidos.id}
                                columns={this.state.columnas}
                                dataSource={this.state.arrResultadoVista}
                                loading={this.state.loading}
                                scroll={{ x: this.state.articuloSelected ? 1300 : 0 }}
                                rowClassName={(record, index) => {
                                    if (index == 0) {
                                        return 'back-nacional';
                                    }
                                    else if (record.es_estado) {
                                        return 'back-estado';
                                    }
                                    else {
                                        return ''
                                    }
                                }}
                            />
                            <Pagination style={{ float: 'right', margin: '16px 0' }} defaultCurrent={1} onChange={(page, pageSize) => this.onChangePagination(page, pageSize)} pageSize={this.state.pageSize} total={this.state.total} size={'small'}></Pagination>
                        </Spin>
                    </div>
                    <DetalleDiferenciaInventario
                        pedido_selected={this.state.objPedidoSelected}
                        esconderModal={(obj) => {
                            let state = { ...this.state }
                            state.objPedidoSelected = null
                            state.mostrarModalDetalle = false;
                            this.setState(state);
                        }}
                        visible={this.state.mostrarModalDetalle}
                        tipo_modal={this.state.tipo_modal}
                    />
                </Card>
            </Spin>
        )
    }
}

export default Form.create()(DiferenciaInventario);